import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetOPDExaminationSummaryDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPDExaminationSummary/GetDetail?` + params, null);

export const CreateOPDExaminationSummary = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPDExaminationSummary/Create`, data);

export const UpdateOPDExaminationSummary = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPDExaminationSummary/Update`, data);

export const GetFullPatientExaminationSummary = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPDExaminationSummary/GetAllExamination?` + params, null);

export const GetPatientExaminationSummary = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPDExaminationSummary/GetExamination?` + params, null);

export const UpdateOPDExaminationByTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPDExaminationSummary/UpdateByTemplate`, data);